/**
 * Where the preview site is, and where Exit goes (PreviewBanner, 2026-09-28).
 * Kept apart from the component so the strip stays a components-only module.
 */
export const LIVE_ORIGIN = 'https://projectmanagement.nadc1.net';

export function isPreviewSite(hostname: string = window.location.hostname): boolean {
  return hostname === 'preview.nadc1.net' || hostname.startsWith('preview.');
}

/** The same page on the live site: path, query and hash carried across. */
export function exitPreviewHref(loc: { pathname: string; search: string; hash: string }, origin: string = LIVE_ORIGIN): string {
  return `${origin}${loc.pathname}${loc.search}${loc.hash}`;
}
